import { Component, ChangeDetectorRef } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { EMPTY } from 'rxjs';

import { BaseFormComponent, FormManagerService } from '@sim/form';

import { BaseApiService } from '@atmi/core';
import { Base, BaseMeta } from '@atmi/core/models';

@Component({
  selector: 'app-base-manager',
  styleUrls: ['./base-manager.component.scss'],
  templateUrl: './base-manager.component.html',
})
export class BaseManagerComponent extends BaseFormComponent<Base> {

  constructor(
    protected readonly snackBarService: MatSnackBar,
    protected readonly translate: TranslateService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly formManager: FormManagerService,
    protected readonly spinner: NgxSpinnerService,
    protected readonly changeDetectionRef: ChangeDetectorRef,
    private readonly baseApi: BaseApiService
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      changeDetectionRef,
      BaseMeta,
      (id) => baseApi.get(id as string),
      '/base',
      router,
    );
  }

  addConcrete(base: Base) {
    return this.baseApi.post(base);
  }

  removeConcrete(base: Base) {
    if (base.id) {
      return this.baseApi.remove(base.id);
    }
    return EMPTY;
  }

  editConcrete(base: Base) {
    return this.baseApi.put(base);
  }

  resetFormConcrete() {
    return EMPTY;
  }
}
